/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TrialSkillRecommendationsControllerCreateMutationRequest, TrialSkillRecommendationsControllerCreateMutationResponse, TrialSkillRecommendationsControllerCreate400, TrialSkillRecommendationsControllerCreate401, TrialSkillRecommendationsControllerCreate403, TrialSkillRecommendationsControllerCreate404 } from "../../models/trialOnboardingSkillRecommendationsController/TrialSkillRecommendationsControllerCreate";

function getTrialSkillRecommendationsControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/trial-onboarding-skill-recommendations` as const }  
  return res
}

/**
 * @summary Recommend tasks from saved trial onboarding answers
 * {@link /api/v1/trial-onboarding-skill-recommendations}
 */
export async function trialSkillRecommendationsControllerCreate(data: TrialSkillRecommendationsControllerCreateMutationRequest, config: Partial<RequestConfig<TrialSkillRecommendationsControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TrialSkillRecommendationsControllerCreateMutationResponse, ResponseErrorConfig<TrialSkillRecommendationsControllerCreate400 | TrialSkillRecommendationsControllerCreate401 | TrialSkillRecommendationsControllerCreate403 | TrialSkillRecommendationsControllerCreate404>, TrialSkillRecommendationsControllerCreateMutationRequest>({ method : "POST", url : getTrialSkillRecommendationsControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}